module.exports = __webpack_public_path__ + "static/media/splash_4.bcb3f435.webp";